/**
 * A function that returns the aspect ratio of an image in number.
 * @param width the width of the image
 * @param height the height of the image
 * @returns the aspect ratio of the image
 * @example
 * getAspectRatioInNumber(16, 9) // 1.7777777777777777
 * getAspectRatioInNumber(4, 3) // 1.3333333333333333
 */
export function getAspectRatioInNumber(width: number, height: number): number {
	return width / height;
}

/**
 * A function that returns the width of an image from its height and aspect ratio.
 * @param width the width of the image
 * @param aspectRatio the aspect ratio of the image
 * @returns the width of the image
 * @example
 * getWidthFromHeight(1080, 16 / 9) // 1920
 * getWidthFromHeight(720, 4 / 3) // 960
 */
export function calculateHeightFromWidth(width: number, aspectRatio: number): number {
	return width / aspectRatio;
}
